import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';
import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import {
  CONSERVATION_UI_MAP_LAYERS,
  LAYER_OPTIONS,
  LayerProps,
  MAP_LAYERS_BY_INDICATOR_PRODUCT,
} from '@/components/widgets/o/Map/constants';
import { useUIStyle } from '@/hooks/useUIStyle';
import { useSelectedIndicatorProducts } from '@/pages/shared/indicators/hooks/useIndicatorProducts';

export const useMapLayers = (defaultLayers: LayerProps[] = []) => {
  const hasConservationUI = useUIStyle(OrganizationUIStyle.CONSERVATION);
  const purchasedIndicatorProducts = useSelectedIndicatorProducts();

  if (!hasConservationUI) {
    return defaultLayers;
  }

  if (purchasedIndicatorProducts.some((ip) => ip.name === INDICATOR.CLEANWAVE)) {
    return MAP_LAYERS_BY_INDICATOR_PRODUCT[INDICATOR.CLEANWAVE]
      .map((fact) => LAYER_OPTIONS.find((layer) => layer.value === fact))
      .filter(Boolean) as LayerProps[];
  }

  return CONSERVATION_UI_MAP_LAYERS.map((fact) => LAYER_OPTIONS.find((layer) => layer.value === fact)).filter(
    Boolean,
  ) as LayerProps[];
};
